import { type ClassValue, clsx } from 'clsx';
import { intervalToDuration } from 'date-fns';
import { twMerge } from 'tailwind-merge';
import type { Nullish } from '@/types/nullish';
import { PANIC_ERROR } from '@/consts/system-errors';
import { isNullish } from './is-nullish';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function fnPlaceholder() {}

/**
 * 生成複製的預設名稱
 * @param originalName 原始名稱
 * @returns 包含 UUID 首段亂碼後綴的新名稱 (e.g., "原始名稱(a1b2c3d4)")
 */
export const generateCopyName = (originalName: string): string => {
  const uuid = crypto.randomUUID();
  const shortId = uuid.split('-')[0];

  return `${originalName}(${shortId})`;
};

export function assertNonNullable<T>(
  value: T | Nullish,
): asserts value is NonNullable<T> {
  if (isNullish(value)) {
    throw PANIC_ERROR;
  }
}

export function fileToBase64(file: File | Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.addEventListener('load', () => {
      if (typeof reader.result !== 'string') return;
      resolve(reader.result);
    });
    reader.addEventListener('error', () => reject(reader.error));
    reader.readAsDataURL(file);
  });
}

export const calculateAge = (birthdate: string) => {
  const birth = new Date(birthdate);
  const today = new Date();

  const {
    years = 0,
    months = 0,
    days = 0,
  } = intervalToDuration({
    start: birth,
    end: today,
  });

  return { years, months, days };
};

export function toNumberOrNull(str: string) {
  const num = str.trim() === '' ? Number.NaN : Number(str);

  return Number.isFinite(num) ? num : null;
}
